import React, { PureComponent } from 'react';
import is from 'is_js';
import { testClass, Sticky, connect } from 'omni-common-ui';
import { Map } from 'immutable';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import invariant from 'invariant';

const APP_BARS_SKELETON = new Map({
  preSticky: new Map(),
  sticky: new Map(),
  postSticky: new Map(),
});

// This is important to avoid new instances being mounted all the time.
const JustDiv = (props) => <div {...props} />;

const EMPTY_ITEM_PROPS = new Map();

export class AppBars extends PureComponent {
  constructor(props) {
    super(props);
    this._parseRoutes(props);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.routes !== newProps.routes) {
      this._parseRoutes(newProps);
    }
  }

  _parseRoutes(newProps) {
    const { routes } = newProps;
    const appBarsConfigArray = routes.filter((routeItem) => is.object(routeItem.appBars))
        .map((routeItem) => routeItem.appBars)
        .map((routeItem) => (is.function(routeItem) ? routeItem(newProps) : routeItem));
    this._appBars = appBarsConfigArray.reduce(
      (appBars, appBarsConfigItem) =>
          appBars.update('preSticky', (previous) => previous.merge(appBarsConfigItem.preSticky))
              .update('sticky', (previous) => previous.merge(appBarsConfigItem.sticky))
              .update('postSticky', (previous) => previous.merge(appBarsConfigItem.postSticky)),
      APP_BARS_SKELETON
    );
  }

  _renderType(type) {
    if (this._appBars.get(type).isEmpty()) {
      return null;
    }

    const Component = type === 'sticky' ? Sticky : JustDiv;
    return <Component className={testClass(`app-bars-${type}`)}>
      {
        this._appBars.get(type)
          .sortBy((item) => item.get('order'))
          .map((item, key) => {
            const Item = item.get('component');
            const itemProps = item.get('props') || EMPTY_ITEM_PROPS;
            invariant(Map.isMap(itemProps), 'AppBars\'s items can only receive props as a JS object');
            // eslint-disable-next-line react/no-array-index-key
            return <Item key={key} {...this.props} {...itemProps.toJS()} />;
          })
      }
    </Component>;
  }

  render() {
    return <div className={testClass('app-bars')}>
      {this._renderType('preSticky')}
      {this._renderType('sticky')}
      {this._renderType('postSticky')}
    </div>;
  }
}

AppBars.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape()),
};

function mapDispatchToProps(dispatch) {
  return { push: (path) => dispatch(push(path)) };
}

export default connect(null, mapDispatchToProps)(AppBars);



// WEBPACK FOOTER //
// ./components/AppBars/index.jsx